import { chain, createSwitcherGroup } from '@leprecoins/effector';
import { createEvent, createStore, sample } from 'effector';
import { or } from 'patronum';
import { shiftModel } from 'entities/shift';
import { receiveCashdeskBalance } from 'shared/api';
import { breakpoints } from 'shared/lib';
import { router } from 'shared/routing';

const createLayoutSwitcher = createSwitcherGroup();

const navbarSwitcher = createLayoutSwitcher();

const asideSwitcher = createLayoutSwitcher();

const $modalsOpened = or(navbarSwitcher.$active, asideSwitcher.$active);

const $openedGames = shiftModel.activatedGameRoute.$isOpened;

const $cashdeskBalance = createStore<number | null>(null);

const closeModals = createEvent();

sample({
	clock: receiveCashdeskBalance.success,
	fn: ({ balance }) => balance,
	target: $cashdeskBalance,
});

sample({
	clock: closeModals,
	target: [navbarSwitcher.disable, asideSwitcher.disable],
});

chain(breakpoints.sm, asideSwitcher.disable);

chain(router.$path, closeModals);

export const cashierLayoutModel = {
	$modalsOpened,
	$openedGames,
	$cashdeskBalance,
	navbarSwitcher,
	asideSwitcher,
	closeModals,
};
